import { getPlatformAPI } from '../platform'

/**
 * Database Migrations
 * Handles schema changes and data migrations between versions
 */

// Future migrations will be added here
// Example:
// db.version(2).stores({
//   tasks: '++id, completed, createdAt, userId, syncedAt, priority',
//   settings: '++id, key, userId, [key+userId]',
//   syncQueue: '++id, synced, timestamp, table',
// }).upgrade(async tx => {
//   // Add default priority to existing tasks
//   await tx.table('tasks').toCollection().modify(task => {
//     task.priority = 'medium'
//   })
// })

/**
 * Migrate offline user data from localStorage to Dexie
 * For backward compatibility with users who have data only in localStorage
 * NOTE: Only runs in Electron (offline mode is not available in web)
 *
 * DEPRECATED: This migration is no longer needed as userProfiles table doesn't exist in current schema
 * Keeping function for compatibility but it does nothing
 */
export async function migrateOfflineDataToDexie(): Promise<void> {
  try {
    // Skip migration in web version (offline mode not supported)
    const platformAPI = getPlatformAPI()
    if (platformAPI.platform === 'web') {
      return
    }

    // Migration deprecated - userProfiles table doesn't exist in current schema
    return
  } catch (error) {
    console.error('[Migration] ❌ Error migrating offline data:', error)
  }
}

/**
 * Check if migration is needed
 */
export async function checkMigrationNeeded(): Promise<boolean> {
  // Add logic to check if migration is needed
  return false
}

/**
 * Run pending migrations
 */
export async function runMigrations(): Promise<void> {
  // Migrations are handled automatically by Dexie
  // This function is for custom migration logic if needed
}
